/**
 * Menu-related translations for Chinese (Simplified) language
 * This file contains translations for navigation and menu items
 */
export default {
  menu: {
    menu: '选单',
    home: '主页',
    profile: '设定',
    wiki: '维基',
    about: '关于',
    stats: '统计',
  },
};
